var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Account',{attrs:{"title":"Branch admin"}},[_c('AccountAdminUserTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }